import type { CompactPlan, Sample } from 'prove-common'

const removedExportIds = new Set([
  'matrixId',
  'productId',
  'sampleTypeId',
  'substanceId',
  'taskId',
  'analysisTypeId',
  'subSampleId',
  'locationId',
  'externalReferenceId',
  'archiveId',
  'resultId',
  'analysisTypeSubstanceId',
  'oversightObject',
  'planIds',
  'labId',
  'sampntTypeId',
  'parentTaskId',
  'payloadSchema'
])

type ExportIdOptions = {
  retainRootId?: boolean
  retainRootPlanId?: boolean
}

export function removeExportIds(
  value: unknown,
  { retainRootId = false, retainRootPlanId = false }: ExportIdOptions = {},
  isRoot = true
): unknown {
  if (Array.isArray(value)) {
    return value.map((item) =>
      removeExportIds(item, { retainRootId, retainRootPlanId }, false)
    )
  }
  if (value == null || typeof value !== 'object') return value

  return Object.fromEntries(
    Object.entries(value as Record<string, unknown>)
      .filter(([key]) => {
        if (removedExportIds.has(key)) return false
        if (key === 'id') return isRoot && retainRootId
        if (key === 'planId') return isRoot && retainRootPlanId
        return true
      })
      .map(([key, nestedValue]) => [
        key,
        removeExportIds(nestedValue, { retainRootId, retainRootPlanId }, false)
      ])
  )
}

export function shapeSampleForStatisticsExport(sample: Sample): unknown {
  const transformed: Sample & { latitude?: number; longitude?: number } = {
    ...sample
  }
  if ('businessName' in sample) transformed.businessName = 'xxxxxx'
  if (
    sample.geometry?.type === 'Point' &&
    Array.isArray(sample.geometry.coordinates)
  ) {
    const [longitude, latitude] = sample.geometry.coordinates
    transformed.latitude = latitude
    transformed.longitude = longitude
    transformed.geometry = undefined
  }

  return removeExportIds(transformed, {
    retainRootId: true,
    retainRootPlanId: true
  })
}

export function shapePlansForStatisticsExport(plans: CompactPlan[]): unknown[] {
  return plans.map((plan) =>
    removeExportIds({ ...plan, planId: plan.id }, { retainRootPlanId: true })
  )
}

export function shapeSelectedPlanForExport<T>(plan: T): unknown {
  return removeExportIds(plan)
}
